import { AppEventSdk } from '@sxm-de/dev-kits/web-sdk/types';

export function recordEddlUpdate(
    appEventSdk: AppEventSdk,
    updates: { [key: string]: unknown },
) {
    appEventSdk.trackEvent({
        event: 'eddl-update',
        updates,
    });
}
